import { BTSelectItem } from "types/apiResponse/apiResponse";

import type { CustomFieldDefinition } from "commonComponents/entity/customField/utils/customFieldDefinition.util";

export { parseCommaSeparatedIds } from "commonComponents/entity/customField/utils/customFieldTypes/customFieldSharedUtils";

interface IHasOptions {
    options?: { id: number; text: string }[];
}

export function getOptionsFromDefinition(definition?: CustomFieldDefinition): BTSelectItem[] {
    if (!definition) return [];
    const def = definition as IHasOptions;
    return (def.options ?? []).map(
        (opt) => new BTSelectItem({ id: opt.id, name: opt.text, value: opt.id }),
    );
}

export function getOptionText(
    selectedOptionId: number,
    definition?: CustomFieldDefinition,
): string {
    if (!definition) return String(selectedOptionId);
    const def = definition as IHasOptions;
    const option = (def.options ?? []).find((opt) => opt.id === selectedOptionId);
    return option?.text ?? String(selectedOptionId);
}

export function getOptionTexts(ids: number[], definition?: CustomFieldDefinition): string {
    if (!definition) return ids.join(", ");
    const def = definition as IHasOptions;
    const options = def.options ?? [];
    return ids
        .map((id) => {
            const opt = options.find((o) => o.id === id);
            return opt?.text ?? String(id);
        })
        .join(", ");
}
